import type { ErrorType } from '~/data/ErrorRecord';

export const initialState: Fields = {
  isSaving: false,
  error: undefined,
};

interface Fields {
  isSaving: boolean;
  error?: ErrorType;
}
